import React, { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import ContentLoader from "../../../../components/mui/general/contentLoader/contentLoader";
import { create_issue } from "../../../../helpers/rights/rights";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import IssueForm from '../../components/form/form'
import useIssue from '../../hooks/useIssue'
import { ISSUES_FORM } from '../../locales/namespaces'

const Create = (props) => {
	const { onClose, isModal, CustId, CustName } = props
	const CustomerId = ({ id: CustId, Description: CustName })
	const { IssueId } = useParams()
	const { t } = useTranslation(ISSUES_FORM)
	const { loading, issue, staticData, issueDataManager } = useIssue({ IssueId })
	
	useEffect(() => {
		document.title = t('New Issue')
	}, [t])
	
	return (
		<Fragment>
			{Object.keys(issue).length > 0 && (
				<IssueForm
					isCreate={true}
					ProjectId={IssueId}
					issue={issue}
					staticData={staticData}
					isQuickAdd={false}
					isModal={isModal}
					assignedType={props.assignedType ? props.assignedType : 'Issue'}
					assignedTypeId={props.assignedTypeId ? props.assignedTypeId : null}
					CustomerId={props.CustId ? CustomerId : null}
					onClose={onClose}
					onSuccess={({formik}) => formik.resetForm()}
					issueDataManager={issueDataManager}
				/>
			)}
			<ContentLoader loading={loading} withBackDrop useCircularLoader message={t('Please wait...')}/>
		</Fragment>
	)
}

export default withPermissionHOC(Create, [create_issue])